import React from 'react';
import PropTypes from 'prop-types';
import AdminDataTable from 'components/admin/AdminDataTable';
import ResultTableTab from 'components/admin/result/ResultTableTab';
import { ageViewHighJumpColumns } from 'config/admin/result';

const AgeViewHighJumpResultDataTable = ({
  clubRole,
  dataTypeOptions = [],
  optionValues,
  handleOptionChange,
  results,
}) => {
  return results.length ? (
    <>
      <ResultTableTab
        dataTypeOptions={dataTypeOptions}
        optionValues={optionValues}
        handleOptionChange={handleOptionChange}
      />
      <AdminDataTable
        borderType="full"
        isAddedFeatures={false}
        columns={ageViewHighJumpColumns}
        data={results}
        searchInputPlaceholder=""
        headStyle={{
          gridTemplateColumns: '1fr 4fr 2fr 2fr 2fr 2fr 2fr 2fr 2fr',
          background: '#f1f1f2',
        }}
        rowStyle={{
          gridTemplateColumns: '1fr 4fr 2fr 2fr 2fr 2fr 2fr 2fr 2fr',
        }}
      />
    </>
  ) : null;
};

AgeViewHighJumpResultDataTable.propTypes = {
  clubRole: PropTypes.string,
  dataTypeOptions: PropTypes.arrayOf(PropTypes.object),
  optionValues: PropTypes.object,
  handleOptionChange: PropTypes.func,
  results: PropTypes.array.isRequired,
};

export default AgeViewHighJumpResultDataTable;
